import appLogger from "@next-platform/client-common-core/logger/appLogger";
import React from "react";

const chatDebugBoundaryLogger = appLogger.withTag("ChatDebugWidget");

type ChatDebugErrorBoundaryProps = {
  children: React.ReactNode;
};

type ChatDebugErrorBoundaryState = {
  hasError: boolean;
};

/**
 * Keeps a failure inside the debug widget (a lazy chunk that fails to load, or a render error on an unexpected
 * payload) from reaching the chat page's error boundary: the widget just disappears and the error is logged.
 */
class ChatDebugErrorBoundary extends React.Component<ChatDebugErrorBoundaryProps, ChatDebugErrorBoundaryState> {
  state: ChatDebugErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ChatDebugErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown): void {
    chatDebugBoundaryLogger.error("Chat debug widget failed and was hidden:", error);
  }

  render(): React.ReactNode {
    return this.state.hasError ? null : this.props.children;
  }
}

export default ChatDebugErrorBoundary;
